var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon",class:{ 'icon-spin' : _vm.spin}},[(_vm.icon)?_c('use',{attrs:{"xlink:href":`#${_vm.icon}`}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }